module.exports = __webpack_public_path__ + "static/media/main-page-background.9e7f6b2f.jpg";